import { useTempExercises } from '@entities/exercise-video/model.ts';
import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useRemoveExercise } from '@features/exercises';
import { useExerciseEditFormPagesRedirect } from '@features/exercises/exercise-form/model/helpres.ts';
import { useSaveScroll } from '@shared/hooks/use-save-scroll.ts';
import { useMenuDropdown } from '@shared/ui';
import { DropdownItem, DropdownMenuWithButton } from '@shared/ui/menus/dropdown-menu';

interface Props {
  videoId: number;
  isTempExercise?: boolean;
}

export const ExerciseMenu = ({ videoId, isTempExercise }: Props): JSX.Element => {
  const navigate = useNavigate();
  const { code } = useParams<{ code: string }>();
  const { clearListScrollData } = useSaveScroll('ExerciseListScrollData');
  const onRemoveAppExercise = () => navigate(`/programs/library/exercises`);
  const { doRedirectWithSavePageUrl } = useExerciseEditFormPagesRedirect();
  const onEdit = () => {
    isTempExercise
      ? doRedirectWithSavePageUrl('edit')
      : doRedirectWithSavePageUrl(`/programs/${code}/exercise-edit/${videoId}`);
    clearListScrollData();
  };

  const { removeExercise: removeAppExercise } = useRemoveExercise({
    videoId,
    onSuccess: onRemoveAppExercise,
  });
  const { removeTempExercise: doRemoveTempExercise } = useTempExercises();

  const removeTempExercise = () => {
    doRemoveTempExercise(videoId);
    doRedirectWithSavePageUrl(`/programs/${code}/exercise-edit/${videoId}`);
  };

  const { menuRef, onClose, handleToggleDropdown, isMenuOpen } = useMenuDropdown({});

  const handleAction = useCallback(
    (action: () => void) => {
      action();
      onClose();
    },
    [onClose]
  );
  const removeExercise = isTempExercise ? removeTempExercise : removeAppExercise;
  return (
    <DropdownMenuWithButton
      isMenuOpen={isMenuOpen}
      onMenuBtnClick={handleToggleDropdown}
      menuRef={menuRef}
    >
      <DropdownItem onClick={() => handleAction(onEdit)}>Изменить</DropdownItem>

      <DropdownItem onClick={() => handleAction(removeExercise)}>Удалить</DropdownItem>
    </DropdownMenuWithButton>
  );
};
